<template>
  <router-link
    class="notification-link"
    :to="{
      name: section,
      params: {
        link: linkData?.link,
      },
    }"
  >
    <el-avatar :size="32" class="notification-link__avatar" v-if="showAvatar">
      <user-avatar :userId="linkData.userId" :alt="linkData.firstName + ' ' + linkData.lastName" />
    </el-avatar>
    <span class="notification-link__name" v-if="section === 'UserProfile'">
      {{ linkData.firstName + ' ' + linkData.lastName }}
    </span>
    <span class="notification-link__name" v-if="section === 'EventPage'">
      {{ linkData.name }}
    </span>
    <span class="notification-link__name" v-if="section === 'TeamPage'">
      {{ linkData.name }}
    </span>
  </router-link>
</template>

<script>
import UserAvatar from '@/components/profile/UserAvatar.vue';
export default {
  name: 'NotificationLink',
  components: {
    UserAvatar,
  },
  props: {
    linkData: {
      type: Object,
      required: true,
    },
    section: {
      type: String,
      required: true,
    },
  },
  computed: {
    showAvatar() {
      return this.section === 'UserProfile';
    },
  },
};
</script>

<style lang="scss">
.notification-link {
  display: flex;
  align-items: center;
  color: var(--color-primary-400);
  white-space: normal;

  * + & {
    margin-left: 0.3em;
  }

  &:hover {
    text-decoration: underline;
  }

  &__avatar {
    margin-right: var(--global-dimension-size-125);
  }
  &__name {
  }
}
</style>
